import { lazy } from "react"
import { RouteProps } from "../features.types"

const DriversLicenseController = lazy(
  () => import("./drivers-license-controller")
)
const DriversLicenseHome = lazy(() => import("./drivers-license"))
const AddDriversLicense = lazy(() => import("./add-drivers-license"))
const EditDriversLicense = lazy(() => import("./edit-drivers-license"))

// define route constant
export const DRIVERS_LICENSE_ROUTE = "drivers-license"
export const ADD_DRIVERS_LICENSE = "drivers-license/add"
export const EDIT_DRIVERS_LICENSE = "drivers-license/edit"

//define routes
export const DriversLicense: RouteProps[] = [
  {
    path: DRIVERS_LICENSE_ROUTE,
    Component: DriversLicenseController,
    children: [
      {
        index: true,
        Component: DriversLicenseHome,
      },
      {
        path: `/${ADD_DRIVERS_LICENSE}`,
        Component: AddDriversLicense,
      },
      {
        path: `/${EDIT_DRIVERS_LICENSE}`,
        Component: EditDriversLicense,
      },
    ],
  },
]
